import icSearch from '../../assets/img/ic-magnifier.svg';

const MobileDiscoverySearchToolbar = ({
    searchValue = '',
    onSearchChange,
    searchPlaceholder = 'Search...',
    searchAriaLabel = 'Search',
    actions = [],
}) => {
    return (
        <div className="mobile-discovery-search-toolbar">
            <div className="mobile-discovery-search-toolbar__search">
                <img src={icSearch} alt="" aria-hidden="true" className="mobile-discovery-search-toolbar__search-icon" />

                <input
                    type="text"
                    className="mobile-discovery-search-toolbar__input"
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(e) => onSearchChange?.(e.target.value)}
                    aria-label={searchAriaLabel}
                />

                {searchValue && (
                    <button
                        type="button"
                        className="mobile-discovery-search-toolbar__clear"
                        onClick={() => onSearchChange?.('')}
                        aria-label="Clear search"
                    >
                        &times;
                    </button>
                )}
            </div>

            {actions.map((action) => (
                <button
                    key={action.label}
                    type="button"
                    className="mobile-discovery-heading__button mobile-discovery-search-toolbar__action"
                    onClick={action.onClick}
                    aria-label={action.label}
                >
                    <img src={action.icon} alt="" aria-hidden="true" />
                </button>
            ))}
        </div>
    );
};

export default MobileDiscoverySearchToolbar;
